import React from "react";
import {Button, ButtonProps, Grid, Typography} from "@mui/material";
import {makeStyles} from "@mui/styles";
import {PortTheme} from "~/ui/theme";


export type ErrorBlockProps = {
    icon: any
    title?: string
    children?: string
    button?: React.ReactElement<ButtonProps>
}


const useStyles = makeStyles<PortTheme>(theme => ({
    root: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        flexWrap: "nowrap",
        padding: "140px 25px 25px",
        flexGrow: 1,
        "@media (max-height: 640px)": {
            paddingTop: "60px"
        }
    },
    iconBox: {
        width: 80,
        height: 80,
        borderRadius: 80,
        backgroundColor: "#6E798C12",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginBottom: 24,
        "& .MuiSvgIcon-root": {
            fontSize: "40px",
            color: theme.palette.secondary.main,
        }
    },
    button: {
        marginTop: 18,
        minWidth: "70%"
    }
}))


export const className = "ErrorBlock";


export const ErrorBlock = (props: ErrorBlockProps) => {
    const {icon, children, title, button} = props;
    const classes = useStyles();

    return (
        <div className={[classes.root, className].filter(Boolean).join(" ")}>
            <div className={classes.iconBox}>
                {icon}
            </div>
            <Grid container direction="column" wrap="nowrap" spacing="4">
                {title && (
                    <Grid item>
                        <Typography variant="screenText" color="secondary" align="center" display="block">
                            {title}
                        </Typography>
                    </Grid>
                )}
                {children && (
                    <Grid item>
                        <Typography variant="screenSubtitle" color="secondary" align="center" display="block">
                            {children}
                        </Typography>
                    </Grid>
                )}
            </Grid>
            {button && (
                React.cloneElement(button, {
                    ...button.props,
                    variant: "contained",
                    size:"small",
                    color:"secondary",
                    className: [classes.button, button.props.className].filter(Boolean).join(" ")
                })
            )}
        </div>
    )
}
